export default __webpack_public_path__ + "static/media/e3-room-bg.55328980.jpg";